import { useState } from 'react';

import ChatIndexEmpty from '@/components/features/chat/layout/ChatIndexEmpty';
import ConversationsList from '@/components/features/chat/layout/ConversationsList';
import CreateChat from '@/components/features/manage/manage-chats/CreateChat';
import { useMediaQuery } from '@/hooks/media-query';

interface ChatContentProps {
  onOpenCreate: () => void;
}

function ChatContent(chatContentProps: ChatContentProps) {
  const { onOpenCreate } = chatContentProps;
  const breakpoint = useMediaQuery('lg');

  if (breakpoint) {
    return (
      <>
        <ConversationsList openCreateConversation={onOpenCreate} />
        <ChatIndexEmpty openCreateConversation={onOpenCreate} />
      </>
    );
  }
  return <ConversationsList openCreateConversation={onOpenCreate} />;
}

export default function ChatIndexPage() {
  const [openCreate, setOpenCreate] = useState<boolean>(false);

  return (
    <div className={'base-direction-row viewport-height box-border min-h-0 overflow-y-auto p-0 md:overflow-y-hidden md:p-4'}>
      <CreateChat open={openCreate} onOpenChange={setOpenCreate} />
      <ChatContent onOpenCreate={() => setOpenCreate(true)} />
    </div>
  );
}
